import type { JSX } from 'react';
import { type ButtonProps, Button } from '@mui/material';
import { styled } from '@mui/styles';
import Color from 'color';

interface Props extends ButtonProps {
  children: string | string[] | JSX.Element;
}

const CoverageButton = ({ children, ...props }: Props) => {
  return (
    <StyledButton variant="outlined" {...props}>
      {children}
    </StyledButton>
  );
};

export default CoverageButton;

const StyledButton = styled(Button)(({ theme }) => {
  return {
    height: '2.15rem',
    padding: '0.5rem 0.25rem',
    minWidth: 'auto',

    color: theme.palette.text.contrastText,
    borderColor:
      theme.palette.mode === 'dark'
        ? theme.config.colors.white
        : Color(theme.config.colors.cowbellBlue).lighten(0.15).toString(),
    '&:hover': {
      borderColor:
        theme.palette.mode === 'dark'
          ? theme.config.colors.white
          : Color(theme.config.colors.cowbellBlue).lighten(0.15).toString(),
    },
  };
});
